<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :actions="actions"
        :beforeSetupGrid="beforeSetupGrid"
        ref="grid"
    ></dx-grid>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Kapures",
        url: "",
        campaignName: "",
        campaigns: [],
        actions: [],

        columns: [
            // {
            //     field: "status",
            //     isIcon: true,
            //     template: "icon",
            //     alignment: "center",
            //     visible: true,
            //     allowFiltering: false,
            //     allowHeaderFiltering: false,
            //     allowHiding: false,
            //     allowSearch: false,
            //     cssClass: "width-25",
            //     headerFilter: {
            //         allowSearch: false,
            //         groupInterval: undefined,
            //         height: undefined,
            //         searchMode: "contains",
            //         width: undefined,
            //     },
            //     icon: (value, row) => {
            //         if (row.isVoided && value == "PROCESSED") {
            //             return "mdi-cancel";
            //         }

            //         switch (value) {
            //             case "PROCESSED":
            //                 return "mdi-check-circle";
            //             case "DECLINED":
            //                 return "mdi-alert";
            //             case "ERROR":
            //                 return "mdi-alert-circle";
            //             default:
            //                 return "";
            //         }
            //     },
            //     iconColor: (value, row) => {
            //         if (row.isVoided && value == "PROCESSED") {
            //             return "#aeb8bf";
            //         }

            //         switch (value) {
            //             case "PROCESSED":
            //                 return "success";
            //             case "DECLINED":
            //             case "ERROR":
            //                 return "#f35123";
            //             default:
            //                 return "#aeb8bf";
            //         }
            //     },
            // },
            {
                label: "User",
                field: "user",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Type",
                field: "paymentType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Site",
                field: "site",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Table Number",
                field: "tableNum",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Male",
                field: "zchurim",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Female",
                field: "nakeivas",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Details",
                field: "transactionDetails",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Comment",
            //     field: "comment",
            //     visible: false,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
        ],
    }),
    methods: {
        async beforeSetupGrid() {
            const campaigns = await this.getCampaigns();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: campaigns,
                value: this.campaignName,
                onSelected: this.onTermSelected,
            });

            this.url =
                "kapures?campaignName=" + encodeURIComponent(this.campaignName);
        },
        async getCampaigns() {
            const campaigns = await this.$http.get("api/Kapures/getCampaigns");

            this.campaigns = campaigns
                .map((c) => c.campaignName)
                .sort(function(a, b) {
                    if (a > b) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
            this.campaignName = this.campaigns[0];

            return this.campaigns;
        },
        onTermSelected(value) {
            this.campaignName = value;

            this.url =
                "kapures?campaignName=" + encodeURIComponent(this.campaignName);

            this.$refs.grid.reloadDataSource(this.url);
        },
    },
};
</script>
<style></style>
